module.exports = "//static.hsappstatic.net/LoginUI/static-1.16112/img/okta-logo.svg"